import { SearchIcon } from '@/components/icons/search-icon';
import { Button } from '@/components/ui/button';
import { useAnimatedDropdown } from '@/hooks/use-animated-dropdown';
import React from 'react';
import { GlobalSearchForm } from './global-search-form';

export const GlobalSearch = (): React.JSX.Element => {
  const { close, containerRef, isClosing, isCollapsed, toggle } = useAnimatedDropdown({ closeOnOutsideClick: true });

  return (
    <div ref={containerRef}
      className="md:relative"
    >
      <Button className="flex shrink-0 items-center gap-1 size-5"
        data-test="button-toggle-search-website"
        size="icon"
        variant="ghost"
        onClick={toggle}
      >
        <span className="sr-only">Search website</span>
        <SearchIcon className="icon icon-primary dont-grow" />
      </Button>
      {!isCollapsed && <GlobalSearchForm isClosing={isClosing}
        onClickOutsideAction={close}
      />}
    </div>
  );
};
